import React from "react";

import _ from "underscore";

import Styles from './../StyleSheet';

const NumberCompareTerminalMixin = {
  renderRelOp() {
    return (<select
      className="form-control"
      style={{ width: this.props.editable ? '190px' : 'auto' }}
      value={this.props.node.get('relop')}
      onChange={this._onRelOpChange}
      disabled={!this.props.editable}
    >
      <option value=">">Greater than</option>
      <option value=">=">Greater than or equal to</option>
      <option value="<">Less than</option>
      <option value="<=">Less than or equal to</option>
      <option value="=">Equal to</option>
      <option value="!=">Not equal to</option>
    </select>);
  },

  renderValue() {
    return (<input
      className="form-control"
      style={this._valueStyles()}
      value={ this.props.node.get('value') }
      onChange={ this._onValueChange }
      disabled={!this.props.editable} />
    );
  },

  _onRelOpChange: function(evt) {
    this.props.node.set('relop', evt.target.value);
  },

  _onValueChange: function(evt) {
    this.props.node.set('value', evt.target.value);
  },

  _valueStyles: function() {
    return (
      _.extend(
        {},
        { width: this.props.editable ? '100px' : 'auto' },
        Styles.lastChild
      )
    );
  }
};

export default NumberCompareTerminalMixin;
